// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `a {
  display: block;
  font-size: 0.875em;
  padding: 12px 40px;
  color: var(--ion-color-light-shade);
  text-decoration: none;
}
a.link-active {
  background-color: var(--ion-color-primary-shade);
}
a:hover {
  background-color: var(--ion-color-primary-shade);
}

.link-content {
  display: flex;
  align-items: center;
}
.link-content span {
  margin-left: 15px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/menu/item-option/item-option.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,mCAAA;EACA,qBAAA;AACF;AAAE;EACE,gDAAA;AAEJ;AAAE;EACE,gDAAA;AAEJ;;AAEA;EACE,aAAA;EACA,mBAAA;AACF;AACE;EACE,iBAAA;AACJ","sourcesContent":["a {\n  display: block;\n  font-size: 0.875em;\n  padding: 12px 40px;\n  color: var(--ion-color-light-shade);\n  text-decoration: none;\n  &.link-active {\n    background-color: var(--ion-color-primary-shade);\n  }\n  &:hover {\n    background-color: var(--ion-color-primary-shade);\n  }\n}\n\n.link-content {\n  display: flex;\n  align-items: center;\n\n  span {\n    margin-left: 15px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
